import { SkeletonText } from '../loaders/SkeletonText';
import { useLoadingValueComponent } from '../v2/hooks/useLoadingValueComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingValue = () => {
  var _useLoadingValueCompo;
  const Skeleton = (_useLoadingValueCompo = useLoadingValueComponent()) !== null && _useLoadingValueCompo !== void 0 ? _useLoadingValueCompo : SkeletonText;
  return /*#__PURE__*/_jsx("span", {
    "data-selenium-test": "formatted-property-value-loading-value",
    "data-test-id": "formatted-property-value-loading-value",
    children: /*#__PURE__*/_jsx(Skeleton, {})
  });
};
export default LoadingValue;